import { useState } from "react";
import { apiClient } from "../../utils/api";
import { ODOCommentCreateRequest, ODOCommentCreateResponse } from "../../types/cs";

const useODOCommentCreate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const createODOComment = async (data: ODOCommentCreateRequest): Promise<boolean> => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.post<ODOCommentCreateResponse>("/api/v1/cs/odo/comment/create", data);
      const { status } = response.data;

      if (status) {
        return true;
      } else {
        throw new Error("댓글 작성에 실패했습니다");
      }
    } catch (error) {
      console.error("댓글 작성 오류:", error);
      setError("네트워크 오류가 발생했습니다. 다시 시도해주세요.");
      return false;
    } finally {
      setIsLoading(false);
    }
  }

  const clearError = () => {
    setError("");
  }

  return {
    isLoading,
    error,
    createODOComment,
    clearError,
  }
}

export default useODOCommentCreate;
